import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

interface Props {
  serviceCenters: any[];
  countries: any[];
  cities: any[];
  citiesLoading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCenters',
  props: {
    serviceCenters: null,
    countries: null,
    cities: null,
    citiesLoading: { type: Boolean }
  },
  emits: ["change-country"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change-country', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  serviceCenters: any[];
  countries: any[];
  cities: any[];
  citiesLoading?: boolean;
};



const selectedCountry = ref(null);
const selectedCity = ref(null);
const activeMarker = ref<number | null>(null);
const markerRefs = ref<any>([]);
const setActiveMarker = (i: number) => {
  activeMarker.value = i;
};
const citiesSelectDisable = computed(
  () =>
    selectedCountry.value === null ||
    props.citiesLoading ||
    (!props.citiesLoading && !props.cities.length),
);

const filteredServiceCenters = computed(() => {
  let result = [];
  if (selectedCountry.value !== null && !selectedCity.value) {
    result = props.serviceCenters.filter(
      (s) => selectedCountry.value === s.countryId,
    );
  } else if (selectedCity.value !== null) {
    result = props.serviceCenters.filter(
      (s) => selectedCity.value === s.cityId,
    );
  } else {
    result = props.serviceCenters;
  }
  return result;
});

const markers = computed(() =>
  filteredServiceCenters.value.map((s) => {
    return {
      title: s.name,
      position: {
        lat: s.lat,
        lng: s.lng,
      },
    };
  }),
);

watch(selectedCountry, (newValue) => {
  selectedCity.value = null;
  activeMarker.value = null;
  emit('change-country', newValue);
});

watch(selectedCity, () => {
  activeMarker.value = null;
});

watch(activeMarker, (value) => {
  if (!value) return;
  const serviceElement = markerRefs.value[value];
  serviceElement.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
  });
});

return { __sfc: true,props, emit, selectedCountry, selectedCity, activeMarker, markerRefs, setActiveMarker, citiesSelectDisable, filteredServiceCenters, markers }
}

})